module.exports = __webpack_public_path__ + "static/media/grassland-weeder.f73a6ec7.svg";